import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy
} from "@angular/core";
import {
    groupBy,
    keyBy,
    map,
    orderBy,
    values
} from "lodash";
import { VirkesorderStatus } from "~app/common/models/constants";
import { IVirkesorderstatus } from "~app/features/transport/transportplanera/models/dtos";
import { VirkesorderstatusIndicatorTexts } from "./virkesorderstatus-indicator.texts";
import { NgClass } from "@angular/common";
@Component({
    selector: "rask-virkesorderstatus-indicator",
    styleUrls: ["./virkesorderstatus-indicator.component.scss"],
    templateUrl: "./virkesorderstatus-indicator.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class VirkesorderstatusIndicatorComponent implements OnChanges {
    @Input() virkesorderstatus: IVirkesorderstatus[];
    @Input() isRaskVo = false;

    statusGroup: IVirkesorderGroup[] = [];
    texts = VirkesorderstatusIndicatorTexts.texts;
    statusText = keyBy(values(VirkesorderStatus.Virkesorderstatusar), x => x.key);

    getGruppText(grupp: IVirkesorderGroup) {
        return `${grupp.nummer} ${grupp.isValsVo ? "(V)" : ""}`;
    }

    getStyle(status: string) {
        return VirkesorderStatus.VirkesorderStatusIconStyle(status);
    }

    getText(status: string) {
        return this.statusText[status]?.value;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.virkesorderstatus) {
            this.statusGroup = orderBy(map(groupBy((changes.virkesorderstatus?.currentValue as IVirkesorderstatus[]) || [], x => x.nummer), grp => ({
                nummer: grp[0].nummer,
                isValsVo: grp[0].isValsVo,
                sortOrder: grp.some(g => g.status === VirkesorderStatus.Makulerad)
                    ? +grp[0].nummer
                    : +grp[0].nummer + 100000000,
                generationer: grp.map(g => ({
                    generation: g.generation,
                    status: g.status
                }))
            })), x => x.sortOrder, "desc");
        }
    }
}

interface IVirkesorderGroup {
    nummer: string;
    isValsVo: boolean;
    generationer: IVirkesorderGeneration[];
}

interface IVirkesorderGeneration {
    generation: number;
    status: string;
}
